let appConfig = require('../../config/index.js')

const ALL_API = {
  // 获取优惠券列表
  listMemberCoupon: {
    method: 'get',
    url: '/api/wechat/listMemberCoupon'
  },
  // 获取优惠券详情
  infoMemberCoupon: {
    method: 'get',
    url: '/api/wechat/infoMemberCoupon'
  },
  // 兑换优惠券
  memberGetExchangeCoupon: {
    baseURL: appConfig.API_URL_MARKET,
    method: 'post',
    url: '/api/onlinemall/couponcenter/memberGetExchangeCoupon'
  }
}

export default ALL_API



// WEBPACK FOOTER //
// ./src/api/coupon/index.js